// extracted by mini-css-extract-plugin
module.exports = {"layout":"SetupCard_layout__KyOmI"};